// extracted by mini-css-extract-plugin
export default {"paginationBar":"PaginationBar_paginationBar__gd3xl"};